import AboutSection from '../sections/AboutSection'

const AboutPage = () => <AboutSection />

export default AboutPage
